<template>
  <WorkPermissionsEditorView :show-header="showHeader" />
</template>

<script setup>
import WorkPermissionsEditorView from '@/views/reports/WorkPermissionsEditorView.vue';

defineProps({
  showHeader: {
    type: Boolean,
    default: true,
  },
});
</script>
